<template>
  <div class="home-hero">
    <div
      class="home-hero d-flex align-items-center justify-content-center"
      :style="{ backgroundImage: `url(${copy.heroImageUrl})` }">
      <div class="text-center home-hero__inner mx-auto">
        <img
          class="home-hero__logo mb-2"
          src="/images/brand/zoop-full-logo-primary.svg">
        <div class="py-2">
          <p class="h3 home-hero__text">
            {{ copy.tagline }}
          </p>
        </div>
        <div class="py-2">
          <p class="h3 home-hero__text mb-5">
            Conveniently Local.
          </p>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <b-button
            class="mx-1 my-1"
            variant="light"
            squared
            to="/listings">
            Start Buying
          </b-button>
          &nbsp;
          <b-button
            class="mx-1 my-1"
            variant="primary"
            squared
            to="/account/listings/new">
            Start Selling
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { copyForRegion } from '@/copy/regionCopy'

export default {
  name: 'HomeHero',
  computed: {
    ...mapGetters('Region', { currentRegion: 'current' }),
    copy() {
      return copyForRegion(this.currentRegion.slug)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/mixins/breakpoints';

.home-hero {
  background-color: #1a6199;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: calc(100vh - 40px);
}

.home-hero__inner {
  width: 80%;
}

.home-hero__text {
  color: #1a6199;
}

.home-hero__logo {
  width: 200px;
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .home-hero__logo {
    width: 200px;
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .home-hero__logo {
    width: 250px;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .home-hero__logo {
    width: 250px;
  }
}

</style>
